import { render, staticRenderFns } from "./DropdownPurchasesEditor.vue?vue&type=template&id=1d26006c"
import script from "./DropdownPurchasesEditor.vue?vue&type=script&lang=js"
export * from "./DropdownPurchasesEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports